import { isNumber, toNumber, isNaN, } from 'lodash'

export const formatInt = val =>
  isNumber(val)
    ? val.toLocaleString()
    : '--'

export const formatPercent = value =>
  isNumber(value)
    ? value < 1
      ? `${Math.round(value * 100)}%`
      : '100%'
    : '--'

// This function found here: https://stackoverflow.com/a/40724354
const SI_SYMBOL = ["", "k", "M", "G", "T", "P", "E"];
export const abbreviateNumber = num => {
    let n = num

    if (!isNumber(n)) {
      try {
        n = toNumber(n)
      } catch (err) { return '--' }
    }

    if (n === 0 || isNaN(n)) { return '--' }
    // what tier? (determines SI symbol)
    const tier = Math.log10(Math.abs(n)) / 3 | 0

    // if zero, we don't need a suffix
    if(tier == 0) return `${Math.round(n)}`

    // get suffix and determine scale
    const suffix = SI_SYMBOL[tier]
    const scale = Math.pow(10, tier * 3)

    // scale the number
    const scaled = n / scale

    // format number and add suffix
    return `${scaled.toFixed(1)}${suffix}`
}

export const formatDuration = (seconds, human = false) => {
  if (!isNumber(seconds) || seconds === 0) { return '--' }

  let newSeconds = seconds
  const days =  Math.floor(newSeconds / 86400)
  newSeconds -= days * 86400
  const hours = Math.floor(newSeconds / 3600)
  newSeconds -= hours * 3600
  const minutes = Math.floor(newSeconds / 60)
  newSeconds -= minutes * 60

  const symbols = [ 'days', 'hrs', 'mins', 'sec' ]

  let retVal = []

  if (!human) {
    retVal = [ days, hours, minutes, newSeconds ]
      .map(v => formatInt(v))
      .filter(s => s.charAt(0) !== '0' && s.charAt(0) !== '-')
      .join(':')
  } else {
    retVal = [ days, hours, minutes, newSeconds ]
      .map((v, idx) => `${formatInt(v)} ${symbols[idx]}`)
      .filter(s => s.charAt(0) !== '0' && s.charAt(0) !== '-')
      .join(', ')
  }

  return retVal.length > 0
    ? retVal
    : '--'
}
